module.exports = "<div>\r\n    <div ng-if=\"$ctrl.vehicleCoveragesExist\">\r\n        <label>{{'quoteandbind.pa.directives.templates.pa-coverage-summary.Vehicle-Specific coverages included' | translate}}</label>\r\n    </div>\r\n    <div ng-if=\"!$ctrl.vehicleCoveragesExist\">\r\n        <label>{{'quoteandbind.pa.directives.templates.pa-coverage-summary.No Vehicle-Specific coverages included' | translate}}</label>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/pa/directives/PaOfferingSelection/mobileQuoteView/mobileCoveragesSummary/mobileCoveragesSummary.html
// module id = 1071
// module chunks = 0